"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileGroupData = exports.DropdownOptionsData = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/* eslint-disable max-classes-per-file */
var TileGroupData = function TileGroupData(title, subtitle, value) {
  (0, _classCallCheck2.default)(this, TileGroupData);
  this.title = title;
  this.subtitle = subtitle;
  this.value = value;
};
exports.TileGroupData = TileGroupData;
var DropdownOptionsData = function DropdownOptionsData(icon, text, value, showArrow) {
  (0, _classCallCheck2.default)(this, DropdownOptionsData);
  this.icon = icon;
  this.text = text;
  this.value = value;
  this.showArrow = showArrow;
};
exports.DropdownOptionsData = DropdownOptionsData;